import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials'
})
export class InitialsPipe implements PipeTransform {
  transform(value: string): string {
    if(!value) return 'N/A';
    return value.split(' ').map(name => name[0]).join('');
  }
}
